import 'css-chunksrc/client/pages/exportsPage/biExportReport/styles.scss';export default {
  "report": "_report_j22dd_1",
  "checked": "_checked_j22dd_7",
  "row": "_row_j22dd_11",
  "checkbox": "_checkbox_j22dd_20",
  "col": "_col_j22dd_26",
  "name": "_name_j22dd_30",
  "description": "_description_j22dd_37",
  "filters": "_filters_j22dd_42",
  "group": "_group_j22dd_51",
  "label": "_label_j22dd_60",
  "button": "_button_j22dd_67",
  "error": "_error_j22dd_71",
  "link": "_link_j22dd_76"
};